import { Box, Flex, FlexProps } from '@rebass/grid';
import Icon from 'components/Icon';
import { formatMoney, formatPercentage } from 'helpers/formatters/number';
import React from 'react';
import { FaCaretDown, FaCaretUp } from 'react-icons/fa';
import { Coin } from 'store/Coin/types';
import { Currency } from 'store/Currency/types';
import withCurrency from 'store/Currency/with-currency';

import {
  AbsoluteChange,
  Container,
  IconWrapper,
  PercentageValue,
  PriceDiff,
} from './styles';

interface Props {
  coin: Coin;
  currency: Currency;
  flexProps?: FlexProps;
}

const CoinSummary = (props: Props) => {
  const { coin, currency, flexProps } = props;

  return (
    <Container {...flexProps}>
      <Flex>
        <Box>
          <IconWrapper>
            <Icon.Coin coin={coin} size={56} />
          </IconWrapper>
        </Box>
        <Box>
          <h1>
            {coin.name} <span>{coin.code}</span>
          </h1>
          <h2>{coin.priceInUSD && formatMoney(coin.priceInUSD, currency)}</h2>
          <PriceDiff>
            {coin.percentChange24h && (
              <PercentageValue percent={coin.percentChange24h}>
                {coin.percentChange24h > 0 && <FaCaretUp />}
                {coin.percentChange24h < 0 && <FaCaretDown />}

                {formatPercentage(coin.percentChange24h)}
              </PercentageValue>
            )}

            {coin.percentChange24h && coin.priceInUSD && (
              <AbsoluteChange>
                {formatMoney(
                  (coin.percentChange24h / 100) * coin.priceInUSD,
                  currency,
                )}
              </AbsoluteChange>
            )}
          </PriceDiff>
        </Box>
      </Flex>
    </Container>
  );
};

export default withCurrency(CoinSummary);
